import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import eventHub from '../helpers/event-hub'

if (document.getElementById('vue-events')) {
  new Vue({
    el: '#vue-events',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json/wp/v2/events`,
        loading: true,
        events: [],
        filters: {
            lang: document.getElementById('vue-events').dataset.lang,
            _embed: 1
        },
        page: 0,
        totalPages: null
      }
    },
    created() {
        moment.locale(document.getElementById('vue-events').dataset.lang);
        this.getEvents()
    },
    computed: {
    },
    methods: {
        getEvents(replace = false) {
        this.loading = true

        this.filters.per_page = 7
        this.filters.offset = this.page*7

        axios
            .get(this.apiUrl, { params: this.filters })
            .then(response => {
                this.events = replace ? response.data : this.events.concat(response.data);
                this.events.forEach((event) => {
                    event.show_details = false
                })
                this.loading = false;
                this.totalPages = response.headers['x-wp-totalpages']
            });
        },
        getFutureEvents() {
            this.filters = {
                lang: document.getElementById('vue-events').dataset.lang,
                _embed: 1,
                future: 1
            }
            this.page = 0
            this.filters.per_page = 7
            this.filters.offset = this.page*7
            this.getEvents(true)
        },
        getPastEvents() {
            this.filters = {
                lang: document.getElementById('vue-events').dataset.lang,
                _embed: 1,
                past: 1
            }
            this.page = 0
            this.filters.per_page = 7
            this.filters.offset = this.page*7
            this.getEvents(true)
        },
        getMore() {
            this.page++
            this.getEvents()
        }
    }
  })

}
